import type { ReactNode } from 'react'

interface BadgeProps {
  label: string
  icon?: ReactNode
  tone?: 'neutral' | 'success' | 'warning'
}

export function Badge({ label, icon, tone = 'neutral' }: BadgeProps) {
  const toneStyle =
    tone === 'success'
      ? {
          borderColor: 'var(--color-success-border)',
          background: 'var(--color-success-bg)',
          color: 'var(--color-success)',
        }
      : tone === 'warning'
        ? {
            borderColor: 'var(--color-warning-border)',
            background: 'var(--color-warning-bg)',
            color: 'var(--color-warning)',
          }
        : {
            borderColor: 'var(--border)',
            background: 'var(--bg-card)',
            color: 'var(--text-muted)',
          }

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border px-2 py-1 text-[9px]"
      style={toneStyle}
    >
      {icon}
      <span>{label}</span>
    </span>
  )
}
